// ADR-0120 §5.1: shared header line for node data previews. Cache previews are
// capped server-side (ADR-0110: ~1,000 rows for file-backed results) while
// `rowCount` carries the true total — when they differ, say so.

export function previewHeaderLabel(
  payload: { rows: unknown[][]; rowCount: number } | null | undefined
): string | null {
  if (!payload) return null;
  if (payload.rows.length >= payload.rowCount) return null;
  return `Previewing first ${payload.rows.length.toLocaleString()} of ${payload.rowCount.toLocaleString()} rows.`;
}
